import { createSlice } from "@reduxjs/toolkit";
import { IOrderItems } from "../interface/IOrderItem";

const initialState: IOrderItems[] | null = null;

const sessionItems = createSlice({
 name: "sessionItems",
 initialState,
 reducers: {
   setSessionItemsInStore: (state, action) => {
     return action.payload;
   },
//    clearSessionItemsInStore: (state) => {
//      return initialState;
//    },
 },
});

export const { setSessionItemsInStore } = sessionItems.actions;

export default sessionItems.reducer;
